<ng-container *ngIf="!isModal; else modalWrapper">
  <section class="pb-form" id="pb-contact-form-id">
    <div class="pb-container pb-py-6 lg:pb-py-0">
      <ng-container *ngTemplateOutlet="formTemplate"></ng-container>
    </div>
  </section>
</ng-container>

<ng-template #modalWrapper>
  <div class="pb-contactFormModal pb-relative pb-z-[1050]" data-contact-modal="true">
    <div
      class="pb-fixed pb-z-[1050] pb-flex pb-items-center pb-justify-center pb-inset-0 pb-backdrop-blur-sm pb-bg-black/30 pb-w-full pb-h-full">
      <div #ContactFormModal
        class="pb-contact-modal pb-scaleUp-wrapper pb-form pb-scaleDown pb-container 3xl:pb-px-12 pb-rounded pb-py-4 pb-max-w-[1440px] pb-h-full 2xl:pb-h-[95%] md:pb-py-8 pb-overflow-y-auto">
        <div class="pb-flex pb-items-center pb-mb-4 pb-justify-end">
          <button (click)="closeModal()" class="pb-flex pb-flex-row pb-items-center">
            <span class="pb-text-sm-m md:pb-text-sm">{{ 'close' | translate }}</span>
            <i class="pb-icon pb-cursor-pointer pb-icon-close pb-text-i-32 pb-icon-color-default"></i>
          </button>
        </div>
        <div>
          <ng-container *ngTemplateOutlet="formTemplate"></ng-container>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #formTemplate>
  <div class="lg:pb-mt-6">
    <div *ngIf="rendering.fields?.Title?.value && swiper?.activeIndex != 4"
      class="pb-text-color-brand pb-text-d-xl-m lg:pb-text-d-xl pb-text-center pb-mb-6 lg:pb-mb-0 pb-w-full lg:pb-w-1/2 pb-mx-auto" data-title="true">
      {{rendering.fields?.Title?.value}}</div>
    <div class="swiper pb-contactForm-swiper lg:pb-min-h-[615px] lg:pb-py-10">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <div class="pb-min-h-[500px] pb-flex pb-flex-col lg:pb-flex-row lg:pb-justify-between">
            <ng-container [ngTemplateOutlet]="Bubble"
              [ngTemplateOutletContext]="{title: rendering.fields?.BubbleTitle1?.value, subtitle: rendering.fields?.BubbleSubtitle1?.value,svg:rendering.fields?.BubbleImage1 }"></ng-container>
            <form [formGroup]="forms[0]" class="pb-flex pb-flex-col pb-gap-y-6 lg:pb-w-1/2">
              <div *ngIf="sector != 'Private' ">
                <label for="individuals" *ngIf="rendering.fields?.Communication?.value">{{rendering.fields?.Communication?.value}}</label>
                <div [formGroup]="forms[0].get('toggles')" class="two-switch-toggle">
                  <input type="radio" formControlName="individualorCompany" id="individuals" name="individuals"
                    data-id="switch2-radio1" value="Individuals" [(ngModel)]="individualorCompanyOption"
                    (change)="onSelectionChange('companyControls','individualControls')" />
                  <label for="individuals">{{rendering.fields?.IndividualSwitchLabel?.value}}</label>
                  <input type="radio" formControlName="individualorCompany" id="company" name="company"
                    data-id="switch2-radio2" value="Company" [(ngModel)]="individualorCompanyOption"
                    (change)="onSelectionChange('individualControls','companyControls')" />
                  <label for="company">{{rendering.fields?.CompanySwitchLabel?.value}}</label>
                  <span data-id="active-label-two-switch"></span>
                </div>
              </div>
              <ng-container [formGroup]="forms[0].get('individualControls')"
                *ngIf="individualorCompanyOption == 'Individuals'; else Company1">
                <div app-form-text-input formControlName="name" [isRequired]="true"
                  [error]="isInputInvalid(forms[0], 'individualControls.name')" [maxLength]="50"
                  [helperText]="isInputInvalid(forms[0], 'individualControls.name') ?  ('mandatory-field' | translate) : '' "
                  [name]="'name'" [id]="'name'" [labelText]="rendering.fields?.Name?.value" [isLarge]="true"  [mask]="maskStringWithSpace">
                </div>
                <div app-form-text-input formControlName="surname" [isRequired]="true"
                  [error]="isInputInvalid(forms[0], 'individualControls.surname') "
                  [helperText]="isInputInvalid(forms[0], 'individualControls.surname') ?  ('mandatory-field' | translate) : '' "
                  [name]="'surname'" [id]="'surname'" [labelText]="rendering.fields?.Surname?.value" [isLarge]="true" [maxLength]="100" [mask]="maskStringWithSpace">
                </div>
                <div app-form-text-input formControlName="fatherName" [isRequired]="true"
                  [error]="isInputInvalid(forms[0], 'individualControls.fatherName')"
                  [helperText]="isInputInvalid(forms[0], 'individualControls.fatherName') ?  ('mandatory-field' | translate) : '' "
                  [name]="'fatherName'" [id]="'fatherName'" [labelText]="rendering.fields?.FatherName?.value"
                  [isLarge]="true"  [mask]="maskStringWithSpace" [maxLength]="100"></div>
              </ng-container>
              <ng-template #Company1>
                <ng-container [formGroup]="forms[0].get('companyControls')"
                  *ngIf="individualorCompanyOption == 'Company' ">
                  <div app-form-text-input formControlName="companyName" [isRequired]="true"
                    [error]="isInputInvalid(forms[0], 'companyControls.companyName')  "
                    [helperText]="isInputInvalid(forms[0], 'companyControls.companyName') ?  ('mandatory-field' | translate) : '' "
                    [name]="'companyName'" [id]="'companyName'" [mask]="maskStringWithSpace" [labelText]="rendering.fields?.CompanyName?.value"
                    [isLarge]="true"></div>
                  <div app-form-text-input formControlName="representative" [isRequired]="true"
                    [error]="isInputInvalid(forms[0], 'companyControls.representative') "
                    [helperText]="isInputInvalid(forms[0], 'companyControls.representative') ?  ('mandatory-field' | translate) : '' "
                    [name]="'representative'" [mask]="maskStringWithSpace" [id]="'representative'"
                    [labelText]="rendering.fields?.Representative?.value" [isLarge]="true"></div>
                </ng-container>
              </ng-template>
              <div>
                <label for="cooperationYes" *ngIf="rendering.fields?.Cooperation?.value">{{rendering.fields?.Cooperation?.value}}</label>
                <div [formGroup]="forms[0].get('toggles')" class="two-switch-toggle">
                  <input type="radio" formControlName="cooperation" id="cooperationYes" name="cooperationYes"
                    data-id="switch2-radio1" value="yes" [(ngModel)]="cooperationOption"
                    (change)="onSelectionChange( 'cooperationControls', 'cooperationControls')" />
                  <label for="cooperationYes">{{ 'yes' | translate }}</label>
                  <input type="radio" formControlName="cooperation" id="cooperationNo" name="cooperationNo"
                    data-id="switch2-radio2" value="no" [(ngModel)]="cooperationOption"
                    (change)="onSelectionChange('cooperationControls' , undefined)" />
                  <label for="cooperationNo">{{ 'no' | translate }}</label>
                  <span data-id="active-label-two-switch"></span>
                </div>
              </div>
              <ng-container [formGroup]="forms[0].get('cooperationControls')" *ngIf="cooperationOption == 'yes'">
                <div app-form-text-input formControlName="tin" [isRequired]="true"
                  [error]="isInputInvalid(forms[0], 'cooperationControls.tin')" [maxLength]="9" [mask]="maskNumber"
                  [helperText]="isInputInvalid(forms[0], 'cooperationControls.tin') ?  ('mandatory-field' | translate) : '' "
                  [name]="'tin'" [id]="'tin'" [labelText]="rendering.fields?.Tin?.value" [isLarge]="true"></div>
              </ng-container>
            </form>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="pb-flex pb-flex-col lg:pb-flex-row lg:pb-justify-between ">
            <ng-container [ngTemplateOutlet]="Bubble"
              [ngTemplateOutletContext]="{title: rendering.fields?.BubbleTitle2?.value, subtitle: rendering.fields?.BubbleSubtitle2?.value,svg:rendering.fields?.BubbleImage2 }"></ng-container>
            <form [formGroup]="forms[1]" class="pb-flex pb-flex-col pb-gap-y-6 lg:pb-w-1/2">
              <div>
                <label for="hasContactedYes" *ngIf="rendering.fields?.HasContacted?.value">{{rendering.fields?.HasContacted?.value}}</label>
                <div [formGroup]="forms[1].get('toggles')" class="two-switch-toggle">
                  <input type="radio" formControlName="hasContacted" id="hasContactedYes" name="hasContactedYes"
                    data-id="switch2-radio1" value="yes" [(ngModel)]="contactedOption"
                    (change)="onSelectionChange( 'hasContactedOptionControls', 'hasContactedOptionControls')" />
                  <label for="hasContactedYes">{{ 'yes' | translate }}</label>
                  <input type="radio" formControlName="hasContacted" id="hasContactedNo" name="hasContactedNo"
                    data-id="switch2-radio2" value="no" [(ngModel)]="contactedOption"
                    (change)="onSelectionChange( 'hasContactedOptionControls', undefined )" />
                  <label for="hasContactedNo">{{ 'no' | translate }}</label>
                  <span data-id="active-label-two-switch"></span>
                </div>
              </div>
              <ng-container [formGroup]="forms[1].get('hasContactedOptionControls')" *ngIf="contactedOption == 'yes'">
                <h3 *ngIf="rendering.fields?.StoreServiceInfoTitle?.value">
                  {{rendering.fields?.StoreServiceInfoTitle?.value}}</h3>
                <div app-form-text-input formControlName="storeService" [isRequired]="true"
                  [error]="isInputInvalid(forms[1], 'hasContactedOptionControls.storeService') "
                  [helperText]="isInputInvalid(forms[1], 'hasContactedOptionControls.storeService') ?  ('mandatory-field' | translate) : '' "
                  [name]="'storeService'" [id]="'storeService'" [maxLength]="50" [mask]="maskStringWithSpace"
                  [labelText]="rendering.fields?.StoreServiceInfoLabel?.value" [isLarge]="true"></div>
                
                  <div app-form-text-input formControlName="person" [isRequired]="false"
                  [name]="'person'" [id]="'person'" [maxLength]="50" [mask]="maskStringWithSpace"
                  [labelText]="rendering.fields?.PersonContaced?.value" [isLarge]="true"></div>              

              </ng-container>
              <div class="pb-space-y-6" [formGroup]="forms[1].get('category')">
                <div *ngIf="selectPlaceholder && sector != 'Private' " app-form-drop-down formControlName="dropDown" [isRequired]="true" [sorting]="false"
                  [error]="isInputInvalid(forms[1], 'category.dropDown') "
                  [helperText]="isInputInvalid(forms[1], 'category.dropDown') ?  ('mandatory-field' | translate) : '' "
                  [name]="'dropDown'" [id]="'dropDown'" [labelText]="rendering.fields?.DropdownLabel?.value"
                  [hasPlaceholder]="true" [placeholderLabel]="selectPlaceholder"   [isDisabled]="false" [options]="options" [isLarge]="true"></div>
                <div app-form-text-area formControlName="area" [isRequired]="true"
                  [error]="isInputInvalid(forms[1], 'category.area') "
                  [helperText]="isInputInvalid(forms[1], 'category.area') ?  ('mandatory-field' | translate) : '' "
                  [name]="'area'" [id]="'contactform-area'" [labelText]="rendering.fields?.TextAreaLabel?.value"
                  [maxLength]="rendering.fields?.TextAreaLimit?.value"></div>
              </div>
              <div class="pb-space-y-2" [formGroup]="forms[1].get('category')">
                <div app-form-file class="pb-w-full" formControlName="files"
                  [allowedFileExtensions]="['.pdf', '.doc', '.docx', '.tiff']" [labelText]="'attachment' | translate"
                  [fileSize]="'4194304'" [filesNumber]="3" (valueChange)="attachmentChange()">
                </div>
              </div>
            </form>
          </div>
        </div>

        <div class="swiper-slide">
          <div class="pb-flex pb-flex-col lg:pb-flex-row lg:pb-justify-between ">
            <ng-container [ngTemplateOutlet]="Bubble"
              [ngTemplateOutletContext]="{title: rendering.fields?.BubbleTitle3?.value, subtitle: rendering.fields?.BubbleSubtitle3?.value,svg:rendering.fields?.BubbleImage3 }"></ng-container>
            <form [formGroup]="forms[2]" class="pb-flex pb-flex-col pb-gap-y-6 lg:pb-w-1/2">
              <div>
                <label for="phone1" *ngIf="rendering.fields?.WayOfCommunication?.value">{{rendering.fields?.WayOfCommunication?.value}}</label>
                <div [formGroup]="forms[2].get('toggles')" class="two-switch-toggle">
                  <input type="radio" formControlName="wayofCommunication" id="phone1" name="phone1"
                    data-id="switch2-radio1" value="phone" [(ngModel)]="wayofCommunicationOption"
                    (change)="onSelectionChange('emailControls','phoneControls')" />
                  <label for="phone1">{{rendering.fields?.PhoneNumberLabel?.value}}</label>
                  <input type="radio" formControlName="wayofCommunication" id="email1" name="email1"
                    data-id="switch2-radio2" value="email" [(ngModel)]="wayofCommunicationOption"
                    (change)="onSelectionChange('phoneControls','emailControls')" />
                  <label for="email1">{{rendering.fields?.EmailLabel?.value}}</label>
                  <span data-id="active-label-two-switch"></span>
                </div>
              </div>

              <ng-container [formGroup]="forms[2].get('phoneControls')"
                *ngIf="wayofCommunicationOption === 'phone'; else Email">
                <div app-form-text-input formControlName="phone" [isRequired]="true"
                  [error]="isInputInvalid(forms[2], 'phoneControls.phone') "
                  [helperText]="isInputInvalid(forms[2], 'phoneControls.phone') ?  ('mandatory-field' | translate) : '' "
                  [name]="'phone'" [id]="'phone'" [mask]="{ mask: '00000000000000' }" [labelText]="rendering.fields?.PhoneNumberInputLabel?.value"
                  [isLarge]="true"></div>
              </ng-container>
              <ng-template [formGroup]="forms[2].get('emailControls')" #Email>
                <ng-container *ngIf="wayofCommunicationOption === 'email'">
                  <div app-form-text-input formControlName="email" [isRequired]="true"
                    [error]="isInputInvalid(forms[2], 'emailControls.email') " [maxLength]="50"
                    [helperText]="isInputInvalid(forms[2], 'emailControls.email') ?   forms[2]['controls']['emailControls']['controls']['email']?.errors?.required ? ('mandatory-field' | translate) : ('email-pattern' | translate) : '' "
                    [name]="'email'" [id]="'email'" [labelText]="rendering.fields?.EmailInputLabel?.value"
                    [isLarge]="true"></div>
                </ng-container>
              </ng-template>

              <!-- <div>
                <label *ngIf="rendering.fields?.TimeSpanLabel?.value">{{rendering.fields?.TimeSpanLabel?.value}}</label>
                <div class="pb-time-radio-wrapper">
                  <ng-container *ngFor="let item of rendering?.fields?.TimeSpanItems">
                      <button type="button" (click)="SelectTime($event)" class="pb-time-radio"> [ngClass]="{'!pb-border-red-10': !timeSelected && timeTrigger}"
                          {{item?.fields?.text?.value}}
                      </button>
                  </ng-container>
                </div>
                <label *ngIf="!timeSelected && timeTrigger" class="pb-error-description pb-text-red-10">{{('mandatory-field' | translate)}}</label>
              </div> -->

            </form>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="pb-flex pb-flex-col lg:pb-flex-row lg:pb-justify-between ">
            <ng-container [ngTemplateOutlet]="Bubble"
              [ngTemplateOutletContext]="{title: rendering.fields?.BubbleTitle4?.value, subtitle: rendering.fields?.BubbleSubtitle4?.value,svg:rendering.fields?.BubbleImage4 }"></ng-container>
            <form [formGroup]="forms[3].get('termsControls')" class="pb-flex pb-flex-col pb-gap-y-6 lg:pb-w-1/2">
              <!-- <a *ngIf="this.rendering.fields?.TermsLink?.value?.href" hybridHref
                [href]="this.rendering.fields?.TermsLink?.value?.href"
                [attr.aria-label]="this.rendering.fields?.TermsLink?.value?.text"
                class="pb-text-md-m md:pb-text-md pb-font-bold pb-flex pb-flex-row pb-items-center pb-gap-2"><span
                  class="pb-underline hover:pb-no-underline">{{this.rendering.fields?.TermsLink?.value?.text}}</span><i
                  class="pb-icon pb-icon-arrow-right pb-text-i-24"></i></a> -->
              <p class="pb-article" *scRichText="rendering?.fields?.TermsContent"></p>
              <div app-form-checkbox formControlName="terms1" [isRequired]="true"
                [error]="isInputInvalid(forms[3], 'termsControls.terms1')"
                [errorMessage]="isInputInvalid(forms[3], 'termsControls.terms1') ?  ('mandatory-field' | translate) : '' "
                name="terms1" id="terms1" [labelTextBottom]="rendering.fields?.Terms1Label?.value" [isChecked]="forms[3].get('termsControls').controls.terms1.value">
              </div>
              <!-- <div app-form-checkbox formControlName="terms2" [isRequired]="true"
                [error]="isInputInvalid(forms[3], 'termsControls.terms2')"
                [errorMessage]="isInputInvalid(forms[3], 'termsControls.terms2') ?  ('mandatory-field' | translate) : '' "
                name="terms2" id="terms2" [labelTextBottom]="rendering.fields?.Terms2Label?.value" [isChecked]="forms[3].get('termsControls').controls.terms2.value">
              </div> -->
            </form>
          </div>
        </div>

        <div class="swiper-slide">
          <!-- {% include "components/breadcrumb/breadcrumb.njk" %} -->
          <div class="restart-swiper pb-mx-auto pb-text-color-brand pb-font-serif pb-text-d-lg pb-text-center pb-max-w-[836px]" *ngIf="callSuccess" data-completion = "success">
            <div class="pb-mb-12 lg:pb-mb-13" >{{rendering.fields?.FinalMessageSuccess?.value}}</div>
            <img class="pb-flex pb-justify-center pb-mx-auto pb-max-w-xl pb-form-illustration"[src]="rendering.fields?.FinalImageSuccess?.value?.src" [alt]="rendering.fields?.FinalImageSuccess?.value?.alt"/>
          </div>
          <div class="restart-swiper pb-mx-auto pb-text-color-brand pb-font-serif pb-text-d-lg pb-text-center pb-max-w-[836px]" *ngIf="!callSuccess" data-completion = "fail">
            <div class="pb-mb-12 lg:pb-mb-13" >{{rendering.fields?.FinalMessageFailure?.value}}</div>
            <img class="pb-flex pb-justify-center pb-mx-auto pb-max-w-xl pb-form-illustration" [src]="rendering.fields?.FinalImageFailure?.value?.src" [alt]="rendering.fields?.FinalImageFailure?.value?.alt"/>
          </div>
        </div>
      </div>
      <div *ngIf="this.swiper && this.swiper?.activeIndex != this.swiper?.slides?.length - 1"
        class="pb-pt-13 pb-flex pb-flex-col lg:pb-flex-row pb-w-full pb-justify-between pb-gap-6">
        <button *ngIf="swiper && swiper?.activeIndex < 3" type="button" (click)="nextSlide()" id="pb-progress-next"
          class="pb-order-2 lg:pb-order-3 swiper-button-next1 pb-btn pb-btn--large pb-btn-primary-brand pb-w-full lg:pb-w-fit after:pb-content-none  pb-z-0">
          {{('next' | translate)}}<i class="pb-icon pb-icon-arrow-right"></i></button>
        <button *ngIf="swiper && swiper?.activeIndex >= 3" type="button" (click)="SubmitForm()" id="pb-progress-next"
          class="pb-order-2 lg:pb-order-3 swiper-button-next1 pb-btn pb-btn--large pb-btn-primary-brand pb-w-full lg:pb-w-fit after:pb-content-none  pb-z-0" [disabled]="LoadingOnSubmit">
          {{('finish' | translate)}}<i *ngIf="!LoadingOnSubmit" class="pb-icon pb-icon-arrow-right"></i><i *ngIf="LoadingOnSubmit" class="pb-icon pb-icon-loading pb-animate-spin"></i></button>
        <button (click)="prevSlide()" *ngIf="swiper && swiper?.activeIndex > 0" type="button" id="pb-progress-prev"
          class="disabled:pb-invisible pb-order-3 lg:pb-order-1 pb-btn pb-btn--large pb-btn-secondary pb-w-full lg:pb-w-fit swiper-button-prev1 after:pb-content-none pb-z-0"><i
            class="pb-icon pb-icon-arrow-left"></i>{{'previous' | translate}}</button>
        <div #progressBar
          class="pb-order-1 lg:pb-order-2 pb-progress-bar pb-w-full pb-flex pb-justify-center pb-items-center pb-gap-1">
          <div id="pb-progress-bar-item-first" class="pb-progress-bar-item active"></div>
          <div class="pb-progress-bar-item"></div>
          <div class="pb-progress-bar-item"></div>
          <div id="pb-progress-bar-item-last" class="pb-progress-bar-item"></div>
        </div>
      </div>
    </div>

  </div>
</ng-template>

<ng-template #Bubble let-Title="title" let-Subtitle="subtitle" let-Svg="svg">
  <div class="pb-mb-6 lg:pb-mb-0 lg:pb-w-1/2">
    <div class="pb-p-5 pb-pb-10 pb-form-bubble pb-relative lg:pb-w-5/6 lg:pb-min-w-[382px] lg:pb-max-w-[707px]">
      <div class="pb-text-d-md-m lg:pb-text-d-md pb-text-color-brand pb-font-serif">{{Title}}</div>
      <div class="pb-text-sm-m lg:pb-text-sm pb-mt-5 lg:pb-mt-4">{{Subtitle}}</div>
    </div>
    <img class="pb-hidden pb-w-fit pb-relative -pb-mt-[40px] pb-z-10 lg:pb-block pb-form-illustration lg:pb-h-80" [src]="Svg?.value?.src" [alt]="Svg?.value?.alt"/>
  </div>
</ng-template>